import { z } from 'zod';

export enum LicenseStatusEnum {
  OK = 'ok',
  EXPIRED = 'expired',
  TOO_MANY_TARGETS = 'too_many_targets',
  TOO_MANY_PROBES = 'too_many_probes',
  NO_LICENSE = 'no_license',
  // Warning states for soft enforcement
  PROBE_OVERAGE = 'probe_overage',
  TARGET_OVERAGE = 'target_overage',
  APPROACHING_PROBE_LIMIT = 'approaching_probe_limit',
  APPROACHING_TARGET_LIMIT = 'approaching_target_limit',
}

export const LicenseSchema = z.object({
  status: z.enum(LicenseStatusEnum),
  expiresAt: z.string().nullable(),

  // Legacy target-based licensing
  numLicensedTargets: z.number().nullable(),
  numTargetsUsed: z.number().nullable(),

  // Probe-based licensing
  numLicensedProbes: z.number().nullable(),
  numProbesUsed: z.number().nullable(),
  contractStartDate: z.string().nullable(),

  customerName: z.string().nullable(),
});

export type LicenseDTO = z.infer<typeof LicenseSchema>;

export const FusionAuthConfigSchema = z.object({
  apiUrl: z.string(),
  appUrl: z.string(),
  applicationId: z.string(),
  redirectUri: z.string(),
  scope: z.string(),
  useFusionAuth: z.boolean(),
});

export const ConfigSchema = z.object({
  enableServerSideJobs: z.boolean(),
  enableServerSettingsPage: z.boolean(),
  enableMakePublic: z.boolean(),
  disableRemediationBundle: z.boolean().optional(),
  auth: z.object({
    fusionauth: FusionAuthConfigSchema,
  }),
  isDangerousPublic: z.boolean(),
  useFusionAuth: z.boolean(),
  isPromptfooCloud: z.boolean(),
  hasAgentProvider: z.boolean(),
  disableTelemetry: z.boolean(),
  autoDiscoveryEnabled: z.boolean(),
  evalCreatorEnabled: z.boolean().optional(),
  disableCloudSignups: z.boolean().optional(),
  version: z.string().optional(),
  needsSetup: z.boolean().optional(),
});

export type FusionAuthConfig = z.infer<typeof FusionAuthConfigSchema>;
export type ConfigDTO = z.infer<typeof ConfigSchema>;
